

export function acalo(za, zb, zc) {
	const sa = parseFloat(za);
	const sb = parseFloat(zb);
	const sc = parseFloat(zc);
	const sn = 3.14159265358979;

	// c1=2*N12/C12/LN(A12/B12)
	const zjc1 = 2 * sn / sc / Math.log(sa / sb);

	// c2=4*N12*(A12-B12)/A12/B12/C12^2/(LN(A12/B12))^3
	const zj1 = sa - sb;
	const zj2 = Math.log(sa / sb);
	const zj3 = zj2 * zj2 * zj2;
	const zjc2 = 4 * sn * zj1 / sa / sb / (sc * sc) / zj3;

	const zjae = zjc1 / zjc2;
	const zjle = zjc1 * zjc1 / zjc2;
	const zjve = zjc1 * zjc1 * zjc1 / zjc2 / zjc2;

	const c1 = +zjc1.toFixed(6);
	const c2 = +zjc2.toFixed(8);
	const ae = +zjae.toFixed(4);
	const le = +zjle.toFixed(4);
	const ve = +zjve.toFixed(4);

	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve};
}



export function acalec(za, zb, zc, zd, ze, zf) {
	const sa = parseFloat(za);
	const sb = parseFloat(zb);
	const sc = parseFloat(zc);
	const sd = parseFloat(zd);
	const se = parseFloat(ze);
	const sf = parseFloat(zf);

	const sn = 3.14159265358979;

	let zj1 = Math.pow(sb * sb - sd * sd, 0.5);
	let zj2 = Math.asin(sd / sb);
	let zj3 = sb + zj1 - 2 * sc;
	let zj4 = sf - se;
	let zj5 = 2 * sa + 4 * sf - sb - 4 * se - zj1;
	let zj6 = 4 * sd * (2 * sa + 4 * sf - 4 * se - zj1);
	let zj7 = 0.596 * sc + sf - se;
	let zj8 = 8 * sd * sf - 8 * sd * se + sc * sc * sn;
	let zj9 = 4 * se / (2 * sa * sd - sd * zj1 - sb * sb * zj2) + (sb + zj1 - 2 * sc) / 4 / sd / zj4;
	let zj10 = 8 * se / sc / sc / sn;
	let zj11 = sn * zj5 / (zj6 - 4 * sb * sb * zj2);
	let zj12 = 2 * sn * zj7 / zj8;
	let zjc1 = zj9 + zj10 + zj11 + zj12;

	let zj13 = sb * sb - sd * sd;
	let zj14 = 2 * sa + 4 * sf - sb - 4 * se - zj1;
	let zj15 = 2 * sa * sd + 4 * sd * sf - 4 * sd * se - sd * zj1 - sb * sb * zj2;
	let zj16 = zj15 * zj15;
	let zj17 = 2 * sd * sf - 2 * sd * se + sc * sc * sn / 4;
	let zj18 = zj17 * zj17;
	let zjj1 = (2 * sd * sa - sd * zj1) - (sb * sb * zj2);
	let zjj2 = zjj1 * zjj1;
	let zj19 = 8 * se / zjj2;
	let zj20 = (sb + zj1 - 2 * sc) / 8 / sd / sd / (zj4 * zj4);
	let zj21 = 32 * se / (sc * sc * sc * sc) / (sn * sn);
	let zj22 = sn * zj14 / zj16;
	let zj23 = sn * zj7 / zj18;
	let zjc2 = zj19 + zj20 + zj21 + zj22 + zj23;

	let zjae = zjc1 / zjc2;
	let zjle = zjc1 * zjc1 / zjc2;
	let zjve = zjc1 * zjc1 * zjc1 / zjc2 / zjc2;

	const c1 = +zjc1.toFixed(6);
	const c2 = +zjc2.toFixed(8);
	const ae = +zjae.toFixed(4);
	const le = +zjle.toFixed(4);
	const ve = +zjve.toFixed(4);

	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve};
}


var sa=0,sb=0,sc=0,sd=0,se=0,sf=0,sn=0;
var	zj1=0,zj2=0,zj3=0,zj4=0,zj5=0,zj6=0,
	zj7=0,zj8=0,zj9=0,zj10=0,zj11=0,zj12=0,
	zj13=0,zj14=0,zj15=0,zj16=0,zj17=0,zj18=0,
	zj19=0,zj20=0,zj21=0,zj22=0,zj23=0,zj24=0,
	zj25=0,zj26=0,zj27=0,zj28=0,zj29=0,zj30=0,zj31=0,
	zj32=0,zj33=0,zj34=0,zj35=0,zj36=0,zj37=0,zj38=0,
	zj39=0,zj40=0,zj41=0,zj42=0,
	zjc1=0,zjc2=0,zjae=0,zjle=0,zjve=0,
	c1=0,c2=0,ae=0,le=0,ve=0,sg=0,
	zja=0,zjb=0,zjc=0,zjd=0,zje=0,zjf=0,zjg=0,
	sk=0,sl=0,sh=0,sj=0,zja1=0,vva=0,va=0,si=0,
	zx1=0,zx2=0,zx3=0,zx4=0,zx5=0,zx55=0,zx6=0,zx7=0,zx8=0
	,zx9=0,zx10=0,zx11=0,zx12=0,zx13=0,zx14=0,zx15=0,zx16=0,
	zx17=0,zx18=0,zx19=0,zx20=0,zx21=0,zx22=0,zx23=0,zx24=0,
	zx25=0,zx26=0,zx27=0,zx28=0,zx29=0,zx30=0,zx31=0,zx32=0,
    sm=0;
export function acalee(za,zb,zc,zd,ze,zf){
	
    sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sn = 3.14159265358979;
	//c1=2*E13*(A13+C13-B13)/C13/D13/(A13-B13)+1/2/D13*((B13-C13)/(F13-E13)+N13)
	zj1=sa+sc-sb;   //(A13+C13-B13)
	zj2=sa-sb;    //(A13-B13)
	zj3=sb-sc;    //(B13-C13)
	zj4=sf-se;    //(F13-E13)
	zj5=2*se*zj1/sc/sd/zj2;  
	//2*E13*(A13+C13-B13)/C13/D13/(A13-B13)
	zj6=zj3/zj4+sn;  
	//((B13-C13)/(F13-E13)+N13
	zj7= 1/2/sd*zj6; 
	 //1/2/D13*((B13-C13)/(F13-E13)+N13)
	zjc1=zj5+zj7;

	//c2=2*E13*((A13-B13)^2+C13^2)/(A13-B13)^2/C13^2/D13^2+(B13-C13)/4/D13^2/(F13-E13)^2+(A13-B13+C13+4*F13-4*E13)*N13/2/D13^2/(A13-B13+2*F13-2*E13)/(2*F13-2*E13+C13)
	zj8=sa-sb+sc+4*sf-4*se;   //(A13-B13+C13+4*F13-4*E13)
	zj9=sa-sb+2*sf-2*se;  //(A13-B13+2*F13-2*E13)
	zj10=2*sf-2*se+sc;    //(2*F13-2*E13+C13)
	zj11=zj2*zj2+sc*sc;  //((A13-B13)^2+C13^2)
	zj12=2*se*zj11/(zj2*zj2)/(sc*sc)/(sd*sd); 
	 //2*E13*((A13-B13)^2+C13^2)/(A13-B13)^2/C13^2/D13^2 用
	 zj13=zj3/4/(sd*sd)/(zj4*zj4);   
	 //(B13-C13)/4/D13^2/(F13-E13)^2 用
	 zj14= zj8*sn/2/(sd*sd)/zj9/zj10;
	 //(A13-B13+C13+4*F13-4*E13)*N13/2/D13^2/(A13-B13+2*F13-2*E13)/(2*F13-2*E13+C13)用
	zjc2=zj12+zj13+zj14;
	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	
	
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
	 return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
	
}

export function acaleed(za,zb,zc,zd,ze,zf,zg){
	 sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	sn = 3.14159265358979;
    
	//c1=2*E16/D16/(A16-B16)+(B16-C16)/2/D16/(F16-E16)+4*E16/(2*G16*C16-G16*(D16*D16-G16*G16)^0.5+D16*D16*ACOS(G16/D16))+N16/4/D16+N16*(C16/2+F16-E16)/(4*D16*(F16-E16)+G16*(2*C16-(D16*D16-G16*G16)^0.5)+D16*D16*ACOS(G16/D16))
	
	zj1=Math.pow(sd*sd-sg*sg,0.5);  //(D16*D16-G16*G16)^0.5
	zj2=Math.acos(sg/sd);  
	//ACOS(G16/D16)
	zjc1=2*se/sd/(sa-sb)+(sb-sc)/2/sd/(sf-se)+4*se/(2*sg*sc-sg*zj1+sd*sd*zj2)+sn/4/sd+sn*(sc/2+sf-se)/(4*sd*(sf-se)+sg*(2*sc-zj1)+sd*sd*zj2);
	
//c2=2*E16/(A16-B16)^2/D16/D16+(B16-C16)/4/D16/D16/(F16-E16)^2+8*E16/(G16*(2*C16-(D16*D16-G16*G16)^0.5)+D16*D16*ACOS(G16/D16))^2+N16/4/D16/D16/((A16-B16)/2+F16-E16)+N16*(C16/2+F16-E16)/16/(D16*(F16-E16)/2+D16*D16*ACOS(G16/D16)/8+G16/8*(2*C16-(D16*D16-G16*G16)^0.5))^2
	   zj3=sa-sb;  //(A16-B16)
	   zj4=zj3*zj3; //(A16-B16)^2
	   zj5=sb-sc;  //(B16-C16)
	   zj6=sf-se;  //(F16-E16)
	   zj7=zj6*zj6;  //(F16-E16)^2
	   zj8=sg*(2*sc-zj1);//(G16*(2*C16-(D16*D16-G16*G16)^0.5)
	   zj9=zj3/2+(sf-se);
	     //((A16-B16)/2+F16-E16)
	    zj10=sc/2+(sf-se);
		//(C16/2+F16-E16)
		zja=zj8+sd*sd*zj2;
		zjb=zja*zja;
		zj11=2*se/zj4/sd/sd+(zj5/4/sd/sd/zj7);
		//2*E16/(A16-B16)^2/D16/D16+(B16-C16)/4/D16/D16/(F16-E16)^2用
		zj12=8*se/zjb;
		//8*E16/(G16*(2*C16-(D16*D16-G16*G16)^0.5)+D16*D16*ACOS(G16/D16))^2用
		zj13=sn/4/sd/sd/zj9;
		//N16/4/D16/D16/((A16-B16)/2+F16-E16)用
	
	    zjc=sd*zj6/2;
		zjd=sd*sd*zj2/8;
	    zje=sg/8*(2*sc-zj1);
	    zjf=zjc+zjd+zje;
		zjg=zjf*zjf;
	
	
	
	
		zj14=sn*zj10/16/zjg;
		//N16*(C16/2+F16-E16)/16/(D16*(F16-E16)/2+D16*D16*ACOS(G16/D16)/8+G16/8*(2*C16-(D16*D16-G16*G16)^0.5))^2 用
		zjc2=zj11+zj12+zj13+zj14;
		
		
		
		
	
   // zjb=Math.asin(sd/sb);
	//zjc=Math.pow(sb*sb-sd*sd,0.5);
	//Math.acos(0.64)
	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	
	
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
   
	 return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
}


export function acalei(za,zb,zc,zd,ze,zf,zg){
	sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	sn = 3.14159265358979;
	
	//c1=E14*(A14-B14+C14)/D14/C14/(A14-B14)+(B14-C14)*(F14-E14+G14)/4/D14/G14/(F14-E14)+N14/2/D14
	zj1=sa-sb+sc;   //(A14-B14+C14)
	zj2=sa-sb;    //(A14-B14)
	zj3=sb-sc;          //(B14-C14)
	zj4=sf-se+sg;   //(F14-E14+G14)
	zj5=sf-se;     //(F14-E14)
	zj6=se*zj1/sd/sc/zj2;
	   //E14*(A14-B14+C14)/D14/C14/(A14-B14)  用
	zj7=zj3*zj4/4/sd/sg/zj5;
	//(B14-C14)*(F14-E14+G14)/4/D14/G14/(F14-E14) 用
	zj8=sn/2/sd;
	//N14/2/D14    用
	zjc1=zj6+zj7+zj8;
	//c2=E14*(A14*A14+B14*B14+C14*C14-2*A14*B14)/(A14-B14)^2/C14/C14/D14/D14+(B14-C14)*(F14*F14+E14*E14+G14*G14-2*F14*E14)/8/D14/D14/G14/G14/(F14-E14)^2+N14*(1/(A14-B14+2*G14)+1/(C14+2*G14)+1/(2*F14-2*E14+C14)+1/(A14-B14+2*F14-2*E14))/4/D14/D14
   zj9=sa*sa+sb*sb+sc*sc-2*sa*sb;  //(A14*A14+B14*B14+C14*C14-2*A14*B14)
   zj10=sf*sf+se*se+sg*sg-2*sf*se;      //(F14*F14+E14*E14+G14*G14-2*F14*E14)
	zj11=sa-sb+2*sg;    //(A14-B14+2*G14)
	zj12=sc+2*sg;    //(C14+2*G14)
	zj13=2*sf-2*se+sc;    //(2*F14-2*E14+C14)
	zj14=sa-sb+2*sf-2*se;      //(A14-B14+2*F14-2*E14)
	zj15=1/zj11+1/zj12+1/zj13+1/zj14;   
	//(1/(A14-B14+2*G14)+1/(C14+2*G14)+1/(2*F14-2*E14+C14)+1/(A14-B14+2*F14-2*E14))
	zj16=se*zj9/(zj2*zj2)/sc/sc/sd/sd;
	//E14*(A14*A14+B14*B14+C14*C14-2*A14*B14)/(A14-B14)^2/C14/C14/D14/D14 用
	zj17=zj3*zj10/8/sd/sd/sg/sg/(zj5*zj5);
	//(B14-C14)*(F14*F14+E14*E14+G14*G14-2*F14*E14)/8/D14/D14/G14/G14/(F14-E14)^2用
	zj18=sn*zj15/4/sd/sd;
	//N14*(1/(A14-B14+2*G14)+1/(C14+2*G14)+1/(2*F14-2*E14+C14)+1/(A14-B14+2*F14-2*E14))/4/D14/D14   用
	zjc2=zj16+zj17+zj18;
	
	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	
	
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
	
	 return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
}


export function acalep(za,zb,zc,zd,ze,zf,zg){
	 sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	sn = 3.14159265358979;
	
	//c1=16*E21/(8*A21*D21-8*B21*G21-N21*B21*B21)+LN(B21/C21)/(F21-E21)/(N21-ATAN(B21/2/G21))+8*E21/C21/C21/N21+(2*(F21-E21)+0.596*C21)/(4*C21*(F21-E21)+C21*C21)+(8*N21*(B21*B21/4+(8*A21*D21-4*B21*C21-N21*B21*B21)/16/(N21-ATAN(B21/2/G21)))^0.5+4*N21*(F21-E21)-4*N21*B21)/(8*A21*D21+8*B21*(F21-E21)*(N21-ATAN(B21/2/G21))-B21*B21*N21-4*B21*C21)
	zj1=8*sa*sd-8*sb*sg-sn*sb*sb;
	//(8*A21*D21-8*B21*G21-N21*B21*B21)
	zj2=16*se/zj1;	
	//16*E21/(8*A21*D21-8*B21*G21-N21*B21*B21)用
	zj3=Math.log(sb/sc);
	//LN(B21/C21)
	zj4=sf-se;//(F21-E21)
	zj5=sn-Math.atan(sb/2/sg);
	//(N21-ATAN(B21/2/G21))
	zj6=zj3/zj4/zj5;
		//LN(B21/C21)/(F21-E21)/(N21-ATAN(B21/2/G21)) 用
	zj7=8*se/sc/sc/sn;
	//8*E21/C21/C21/N21 用
	zj8=2*zj4+0.596*sc;
	//(2*(F21-E21)+0.596*C21)
	zj9=4*sc*zj4+sc*sc;
	//(4*C21*(F21-E21)+C21*C21)
	zj10=zj8/zj9;
	//(2*(F21-E21)+0.596*C21)/(4*C21*(F21-E21)+C21*C21) 用
	zj11=8*sa*sd-4*sb*sc-sn*sb*sb;
	//(8*A21*D21-4*B21*C21-N21*B21*B21)
	zj12=sb*sb/4+zj11/16/zj5;
	//(B21*B21/4+(8*A21*D21-4*B21*C21-N21*B21*B21)/16/(N21-ATAN(B21/2/G21)))
	zj13=Math.pow(zj12,0.5);
	//(B21*B21/4+(8*A21*D21-4*B21*C21-N21*B21*B21)/16/(N21-ATAN(B21/2/G21)))^0.5
	zj14=8*sn*zj13+4*sn*zj4-4*sn*sb;
	
	zj15=zj14/(8*sa*sd+8*sb*zj4*zj5-sb*sb*sn-4*sb*sc);
	//(8*N21*(B21*B21/4+(8*A21*D21-4*B21*C21-N21*B21*B21)/16/(N21-ATAN(B21/2/G21)))^0.5+4*N21*(F21-E21)-4*N21*B21)/(8*A21*D21+8*B21*(F21-E21)*(N21-ATAN(B21/2/G21))-B21*B21*N21-4*B21*C21)用
	
	zjc1=zj2+zj6+zj7+zj10+zj15;
	
	
	
    //c2=2*E21/(A21*D21-N21*B21*B21/8-B21*G21)^2+(B21-C21)/B21/C21/(F21-E21)^2/(N21-ATAN(B21/2/G21))^2+32*E21/N21/N21/C21^4+(0.298*C21+F21-E21)/N21/(C21*C21/4+(F21-E21)*C21)^2+(N21*(F21-E21)-N21*B21+2*N21*(B21*B21/4+(8*A21*D21-4*B21*C21-N21*B21*B21)/16/(N21-ATAN(B21/2/G21)))^0.5)/(A21*D21+B21*(F21-E21)*(N21-ATAN(B21/2/G21))-B21*B21*N21/8-B21*C21/2)^2
	
	 zj16=sa*sd-sn*sb*sb/8-sb*sg;
	 
	 //(A21*D21-N21*B21*B21/8-B21*G21)
	 zj17=zj16*zj16;
	 //(A21*D21-N21*B21*B21/8-B21*G21)^2
	 zj18=2*se/zj17;
	//2*E21/(A21*D21-N21*B21*B21/8-B21*G21)^2 用
	zj19=sb-sc;//(B21-C21)
	zj20=zj19/sb/sc/(zj4*zj4)/(zj5*zj5);
	//(B21-C21)/B21/C21/(F21-E21)^2/(N21-ATAN(B21/2/G21))^2  用
	zj21=32*se/sn/sn/(sc*sc*sc*sc);
	//32*E21/N21/N21/C21^4  用
	zj22=0.298*sc+sf-se;
	//(0.298*C21+F21-E21)
	zj23=sc*sc/4+zj4*sc;
	zj24=zj23*zj23;
	zj25=zj22/sn/zj24;
	//(0.298*C21+F21-E21)/N21/(C21*C21/4+(F21-E21)*C21)^2  用
	zj26=8*sa*sd-4*sb*sc-sn*sb*sb;
	//(8*A21*D21-4*B21*C21-N21*B21*B21)
	zj27=sb*sb/4+zj26/16/zj5;
	zj28=Math.pow(zj27,0.5);
	//(B21*B21/4+(8*A21*D21-4*B21*C21-N21*B21*B21)/16/(N21-ATAN(B21/2/G21)))^0.5
	zj29=sa*sd+sb*zj4*zj5-sb*sb*sn/8-sb*sc/2;
	//(A21*D21+B21*(F21-E21)*(N21-ATAN(B21/2/G21))-B21*B21*N21/8-B21*C21/2)^2
	zj30=zj29*zj29;
	//(A21*D21+B21*(F21-E21)*(N21-ATAN(B21/2/G21))-B21*B21*N21/8-B21*C21/2)^2
	zj31=(sn*zj4-sn*sb+2*sn*zj28)/zj30;
	//(N21*(F21-E21)-N21*B21+2*N21*(B21*B21/4+(8*A21*D21-4*B21*C21-N21*B21*B21)/16/(N21-ATAN(B21/2/G21)))^0.5)/(A21*D21+B21*(F21-E21)*(N21-ATAN(B21/2/G21))-B21*B21*N21/8-B21*C21/2)^2用
	zjc2=zj18+zj20+zj21+zj25+zj31;
	
	
	
	
	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	
	
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4); 
	
	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
	
}



export function acalepc1(za,zb,zk,zc,zd,zl,ze,zf,zh){
	 sa = parseFloat(za);
    sb = parseFloat(zb);
	sk = parseFloat(zk);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	sl = parseFloat(zl);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sh = parseFloat(zh);
	
	sn = 3.14159265358979;
	
	//c1=8*E19/(4*L19*(A19-B19)+3*(B19-K19)*(L19-D19))+(B19-C19)/2/(F19-E19)/(L19-H19)+2*E19/C19/D19+16*((N19/8*((A19-B19)/2+F19-E19))^2+H19*H19/4)^0.5/(4*L19*(A19-B19)+3*(B19-K19)*(L19-D19)+8*(F19-E19)*(L19-H19))+4*((N19*(F19-E19+C19/2)/8)^2+(L19-D19-H19)^2/4)^0.5/(2*(F19-E19)*(L19-H19)+C19*D19)
	zj1=sa-sb;//(A19-B19)
	zj2=sb-sk;     //(B19-K19)
	zj3=sl-sd;    //(L19-D19)
	zj4=sb-sc;    //(B19-C19)
	zj5=sf-se;  //(F19-E19)
	zj6=sl-sh;   //(L19-H19)
	zj7=sf-se+sc/2;
	  //(F19-E19+C19/2)
	 zj8=sl-sd-sh;  //(L19-D19-H19)
	 zj9=sn/8*(zj1/2+sf-se);
	 //(N19/8*((A19-B19)/2+F19-E19)
	 zj10=zj9*zj9;
	 //(N19/8*((A19-B19)/2+F19-E19)^2
	
	zj11=Math.pow(zj10+sh*sh/4,0.5);  
	//((N19/8*((A19-B19)/2+F19-E19))^2+H19*H19/4)^0.5
	zj12=sn*zj7/8;
	 //(sn*zj7/8)
	 zj13=Math.pow(zj12*zj12+zj8*zj8/4,0.5); 
	 //((N19*(F19-E19+C19/2)/8)^2+(L19-D19-H19)^2/4)^0.5
	zjc1=8*se/(4*sl*zj1+3*zj2*zj3)+zj4/2/zj5/zj6+2*se/sc/sd+16*zj11/(4*sl*zj1+3*zj2*zj3+8*zj5*zj6)+4*zj13/(2*zj5*zj6+sc*sd);
	
	
	//c2=E19/2/(L19/2*(A19-B19)+3/8*(B19-K19)*(L19-D19))^2+(B19-C19)/4/(F19-E19)^2/(L19-H19)^2+2*E19/C19/C19/D19/D19+((N19*((A19-B19)/2+F19-E19)/8)^2+H19*H19/4)^0.5/2/(L19*(A19-B19)/4+3/16*(B19-K19)*(L19-D19)+(F19-E19)*(L19-H19)/2)^2+((N19*(F19-E19+C19/2)/8)^2+(L19-D19-H19)^2/4)^0.5/2/((F19-E19)*(L19-H19)/2+C19*D19/4)^2
	
	//zj13=se/2/(sl/2*zj1+3/8*zj2*zj3)^2+zj4/4/zj5^2/zj6^2+2*se/sc/sc/sd/sd+((sn*(zj1/2+sf-se)/8)^2+sh*sh/4)^0.5/2/(sl*zj1/4+3/16*zj2*zj3+zj5*zj6/2)^2+((sn*zj7/8)^2+zj8^2/4)^0.5/2/(zj5*zj6/2+sc*sd/4)^2
	
	
	zj15=se/2/Math.pow(sl/2*zj1+3/8*zj2*zj3,2);
	//se/2/(sl/2*zj1+3/8*zj2*zj3)^2 用
	zj16=zj4/4/(zj5*zj5)/(zj6*zj6);
	//(B19-C19)/4/(F19-E19)^2/(L19-H19)^2
	//zj4/4/zj5^2/zj6^2  用
	zj17=2*se/sc/sc/sd/sd;
	//2*E19/C19/C19/D19/D19
	//2*se/sc/sc/sd/sd  用
	zj18=sl*zj1/4+(3/16*zj2*zj3)+(zj5*zj6/2);
	//(L19*(A19-B19)/4+3/16*(B19-K19)*(L19-D19)+(F19-E19)*(L19-H19)/2)
	zj19=zj18*zj18;
	//(L19*(A19-B19)/4+3/16*(B19-K19)*(L19-D19)+(F19-E19)*(L19-H19)/2)^2
	zj20=sn*(zj1/2+sf-se)/8;
	zj21=zj20*zj20;  
	//(N19*((A19-B19)/2+F19-E19)/8)^2
	zj22=zj21+sh*sh/4;
	zj23=Math.pow(zj22,0.5);
	//(sn*(zj1/2+sf-se)/8)^2+sh*sh/4)^0.5
	zj24=zj23/2/zj19;
	//((sn*(zj1/2+sf-se)/8)^2+sh*sh/4)^0.5/2/(sl*zj1/4+3/16*zj2*zj3+zj5*zj6/2)^2用
	zj25=(zj5*zj6/2+sc*sd/4)*(zj5*zj6/2+sc*sd/4);
	//((F19-E19)*(L19-H19)/2+C19*D19/4)^2
	zj26=(zj13/2/zj25);
	//((sn*zj7/8)^2+zj8^2/4)^0.5/2/(zj5*zj6/2+sc*sd/4)^2  用
	zjc2=zj15+zj16+zj17+zj24+zj26;
	
	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	
	
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
	
}


export function acalepc2(za,zb,zk,zc,zd,zl,ze,zf,zh){
	
    sa = parseFloat(za);
    sb = parseFloat(zb);
	sk = parseFloat(zk);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	sl = parseFloat(zl);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sh = parseFloat(zh);
	
	sn = 3.14159265358979;
	
	
	
	//c1=8*E20/(4*L20*(A20-B20)+3*(B20-K20)*(L20-D20))+(B20-C20)/2/(F20-E20)/(L20-H20)+8*E20/(4*C20*D20+D20*D20*(N20-4))+16*((N20/8*((A20-B20)/2+F20-E20))^2+H20*H20/4)^0.5/(4*L20*(A20-B20)+3*(B20-K20)*(L20-D20)+8*(F20-E20)*(L20-H20))+16*((N20*(F20-E20+C20/2)/8)^2+(L20-D20-H20)^2/4)^0.5/(8*(F20-E20)*(L20-H20)+4*C20*D20+D20*D20*(N20-4))
	
	zj1=sa-sb;//(A19-B19)
	zj2=sb-sk;     //(B19-K19)
	zj3=sl-sd;    //(L19-D19)
	zj4=sb-sc;    //(B19-C19)
	zj5=sf-se;  //(F19-E19)
	zj6=sl-sh;   //(L19-H19)
	
	
	zj7=8*se/(4*sl*zj1+3*zj2*zj3);
	//8*E20/(4*L20*(A20-B20)+3*(B20-K20)*(L20-D20))  用
	zj8=zj4/2/zj5/zj6;
	//(B20-C20)/2/(F20-E20)/(L20-H20)用
	zj9=8*se/(4*sc*sd+sd*sd*(sn-4));
	//8*E20/(4*C20*D20+D20*D20*(N20-4)) 用
	zj10=sn/8*(zj1/2+sf-se);
	//(N20/8*((A20-B20)/2+F20-E20))
	zj11=zj10*zj10;
	//(N20/8*((A20-B20)/2+F20-E20))^2
	zj12=zj11+sh*sh/4;
	zj13=Math.pow(zj12,0.5); 
	//((N20/8*((A20-B20)/2+F20-E20))^2+H20*H20/4)^0.5
	zj14=4*sl*zj1+3*zj2*zj3+8*zj5*zj6;
	//(4*L20*(A20-B20)+3*(B20-K20)*(L20-D20)+8*(F20-E20)*(L20-H20))
	zj15=16*zj13/zj14;
	//16*((N20/8*((A20-B20)/2+F20-E20))^2+H20*H20/4)^0.5/(4*L20*(A20-B20)+3*(B20-K20)*(L20-D20)+8*(F20-E20)*(L20-H20))  用
	zj16=sn*(sf-se+sc/2)/8;  
	//(N20*(F20-E20+C20/2)/8)
	zj17=zj16*zj16;
	//(N20*(F20-E20+C20/2)/8)^2
	zj18=(sl-sd-sh)*(sl-sd-sh);
	//(L20-D20-H20)^2
	zj19=Math.pow(zj17+zj18/4,0.5);
	zj20=8*zj5*zj6+4*sc*sd+sd*sd*(sn-4);
	zj21=16*zj19/zj20;
	//16*((N20*(F20-E20+C20/2)/8)^2+(L20-D20-H20)^2/4)^0.5/(8*(F20-E20)*(L20-H20)+4*C20*D20+D20*D20*(N20-4))用
	
	zjc1=zj7+zj8+zj9+zj15+zj21;
	
	
	
	//c2=E20/2/(L20/2*(A20-B20)+3/8*(B20-K20)*(L20-D20))^2+(B20-C20)/4/(F20-E20)^2/(L20-H20)^2+E20/2/(C20*D20/2+D20*D20/8*(N20-4))^2+((N20*((A20-B20)/2+F20-E20)/8)^2+H20*H20/4)^0.5/2/(L20*(A20-B20)/4+3/16*(B20-K20)*(L20-D20)+(F20-E20)*(L20-H20)/2)^2+((N20*(F20-E20+C20/2)/8)^2+(L20-D20-H20)^2/4)^0.5/2/((F20-E20)*(L20-H20)/2+C20*D20/4+D20*D20/16*(N20-4))^2
	
	zj22=sl/2*zj1+3/8*zj2*zj3;
	zj23=zj22*zj22;
	
	zj24=se/2/zj23;
	//E20/2/(L20/2*(A20-B20)+3/8*(B20-K20)*(L20-D20))^2 用
	
	zj25=zj4/4/(zj5*zj5)/(zj6*zj6);
	//(B20-C20)/4/(F20-E20)^2/(L20-H20)^2  用
	zj26=sc*sd/2+sd*sd/8*(sn-4);
	zj27=zj26*zj26;
	zj28=se/2/zj27;
	//E20/2/(C20*D20/2+D20*D20/8*(N20-4))^2 用
	
    zj29=sn*(zj1/2+sf-se)/8;
	//(N20*((A20-B20)/2+F20-E20)/8)
	zj30=zj29*zj29;
	//(N20*((A20-B20)/2+F20-E20)/8)^2
		zj31=Math.pow(zj30+sh*sh/4,0.5);
		//((N20*((A20-B20)/2+F20-E20)/8)^2+H20*H20/4)^0.5
		zj32=sl*zj1/4+3/16*zj2*zj3+zj5*zj6/2;
		//(L20*(A20-B20)/4+3/16*(B20-K20)*(L20-D20)+(F20-E20)*(L20-H20)/2)
		zj33=zj32*zj32;
		//(L20*(A20-B20)/4+3/16*(B20-K20)*(L20-D20)+(F20-E20)*(L20-H20)/2)^2
		zj34=zj31/2/zj33;
		//((N20*((A20-B20)/2+F20-E20)/8)^2+H20*H20/4)^0.5/2/(L20*(A20-B20)/4+3/16*(B20-K20)*(L20-D20)+(F20-E20)*(L20-H20)/2)^2用
	zj35=sn*(sf-se+sc/2)/8;
	zj36=zj35*zj35;
	//(N20*(F20-E20+C20/2)/8)^2
	zj37=(sl-sd-sh)*(sl-sd-sh);
	//(L20-D20-H20)^2
	zj38=Math.pow(zj36+zj37/4,0.5);
	//((N20*(F20-E20+C20/2)/8)^2+(L20-D20-H20)^2/4)^0.5
	zj39=zj5*zj6/2+sc*sd/4+sd*sd/16*(sn-4);
	zj40=zj39*zj39;
	zj41=zj38/2/zj40;
	//((N20*(F20-E20+C20/2)/8)^2+(L20-D20-H20)^2/4)^0.5/2/((F20-E20)*(L20-H20)/2+C20*D20/4+D20*D20/16*(N20-4))^2  用
	zjc2=zj24+zj25+zj28+zj34+zj41;
	
	
	
	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	
	
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
}


export function acalet(za,zb,zc,zd,ze,zf){
	
    sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	
	sn = 3.14159265358979;
	
//c1=E18*(A18-B18+C18)/C18/D18/(A18-B18)+1/D18*((B18-C18)/(F18-E18)+N18/2)
zjc1=se*(sa-sb+sc)/sc/sd/(sa-sb)+1/sd*((sb-sc)/(sf-se)+sn/2);

//c2=E18/D18/D18/(A18-B18)^2+(B18-C18)/D18/D18/(F18-E18)^2+E18/D18/D18/C18/C18+N18/2/D18/D18/(A18-B18+F18-E18)+N18/2/D18/D18/(F18-E18+C18)
    zj1=sa-sb;  //(A18-B18)
	zj2=zj1*zj1;   //(A18-B18)^2
	zj3=sf-se;   //(F18-E18)
	zj4=zj3*zj3;  //(F18-E18)^2
	zj5=sa-sb+sf-se;   //(A18-B18+F18-E18)
	zj6=sf-se+sc;  //(F18-E18+C18)
    zjc2=se/sd/sd/zj2+(sb-sc)/sd/sd/zj4+se/sd/sd/sc/sc+sn/2/sd/sd/zj5+sn/2/sd/sd/zj6;

	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	
	
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
	
	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
}


export function acalft(za,zb,zc,zd,ze,zf){
	
	 sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	
	sn = 3.14159265358979;

//c1=B17/C17/D17+4*E17/D17/(A17-B17)+B17/D17/(F17-E17-C17)+N17/D17
  zjc1=sb/sc/sd+4*se/sd/(sa-sb)+sb/sd/(sf-se-sc)+sn/sd;
  

//c2=B17*(C17*C17+(F17-E17-C17)^2)/D17/D17/C17/C17/(F17-E17-C17)^2+8*E17/(A17-B17)^2/D17^2+N17/D17/D17*(1/(C17+(A17-B17)/2)+1/(F17-E17-C17+(A17-B17)/2))
    zj1=sf-se-sc;  //(F17-E17-C17)
	zj2=zj1*zj1;   //(F17-E17-C17)^2
	zj3=sc*sc+zj2;   //(C17*C17+(F17-E17-C17)^2)
	zj4=sa-sb;   //(A17-B17)
	zj5=zj4*zj4;   //(A17-B17)^2
	zj6=zj4/2;   
	//(A17-B17)/2
	zj7=sc+zj6;
		    //(C17+(A17-B17)/2);
		zja=1/zj7
		//1/(C17+(A17-B17)/2)
	zj8=sf-se-sc+zj6;
     //(F17-E17-C17+(A17-B17)/2)
     zjb=1/zj8;
   //1/(F17-E17-C17+(A17-B17)/2)
   zjc=zja+zjb;
//(1/(C17+(A17-B17)/2)+1/(F17-E17-C17+(A17-B17)/2))

zj9=sb*zj3/sd/sd/sc/sc/zj2;
//B17*(C17*C17+(F17-E17-C17)^2)/D17/D17/C17/C17/(F17-E17-C17)^2用

zj10=8*se/zj5/(sd*sd);
//8*E17/(A17-B17)^2/D17^2用

zj11=sn/sd/sd*zjc;
//N17/D17/D17*(1/(C17+(A17-B17)/2)+1/(F17-E17-C17+(A17-B17)/2))


zjc2=zj9+zj10+zj11;


	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	
	
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
}


export function acalpm(za,zb,zc,zd,ze,zf,zg,zh,zj){
	sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	sh = parseFloat(zh);
	sj = parseFloat(zj);
	sn = 3.14159265358979;
	
	
	
	//c1=8*E22/(N22*(A22*A22-B22*B22-J22*J22)-2*(A22*A22-B22*B22)*ASIN(G22/B22))+(B22+C22)*LN(B22/C22)*((B22-C22)/2+((B22*B22+C22*C22)/4-B22*C22/2*COS(ASIN(G22/B22)))^0.5)/(F22-E22)/(2*H22*G22+N22*(B22*B22-C22*C22)-2*B22*B22*ASIN(G22/B22))+8*E22/N22/(C22*C22-D22*D22)+N22*(2*F22-2*E22+A22-B22)/(N22*(A22*A22-B22*B22-J22*J22)+4*N22*B22*(F22-E22)-(8*B22*(F22-E22)+2*(A22*A22-B22*B22))*ASIN(G22/B22))+(2*C22+2*F22-2*E22-2*((C22*C22+D22*D22)/2)^0.5)/(C22*C22-D22*D22+4*C22*F22-4*C22*E22)
	zj1=sa*sa-sb*sb-sj*sj;
	//(A22*A22-B22*B22-J22*J22)
	zj2=sa*sa-sb*sb;
	//(A22*A22-B22*B22)
	zj3=Math.asin(sg/sb);
	//ASIN(G22/B22)
	zj4=8*se/(sn*zj1-2*zj2*zj3);
	//8*E22/(N22*(A22*A22-B22*B22-J22*J22)-2*(A22*A22-B22*B22)*ASIN(G22/B22)) 用
	
	zj5=sb+sc;//(B22+C22)
	zj6=sb-sc;//(B22-C22)
	zj7=Math.log(sb/sc);
	//LN(B22/C22)
	zj8=sb*sb+sc*sc;
	//(B22*B22+C22*C22)
	zj9=Math.cos(zj3);
	//COS(ASIN(G22/B22)
	zja1=(sb*sc/2)*zj9;
	zj10=zj8/4-zja1;
	//zj10有问题应该=168.25 显示在C2
	zj11=Math.pow(zj10,0.5);
	//((B22*B22+C22*C22)/4-B22*C22/2*COS(ASIN(G22/B22)))^0.5
	zj12=sf-se;//(F22-E22)
	zj13=sb*sb-sc*sc;
	//(B22*B22-C22*C22)
	zj14=zj5*zj7*(zj6/2+zj11)/zj12/(2*sh*sg+sn*zj13-2*sb*sb*zj3);
	//(B22+C22)*LN(B22/C22)*((B22-C22)/2+((B22*B22+C22*C22)/4-B22*C22/2*COS(ASIN(G22/B22)))^0.5)/(F22-E22)/(2*H22*G22+N22*(B22*B22-C22*C22)-2*B22*B22*ASIN(G22/B22)) 用
	zj15=sc*sc-sd*sd;
	//(C22*C22-D22*D22) 
	zj16=8*se/sn/zj15;
	//8*E22/N22/(C22*C22-D22*D22)  用
	zj17=2*sf-2*se+sa-sb;
	//(2*F22-2*E22+A22-B22)
	zj18=sa*sa-sb*sb-sj*sj;
	//(A22*A22-B22*B22-J22*J22)
	zj19=8*sb*zj12+2*zj2;
	//(8*B22*(F22-E22)+2*(A22*A22-B22*B22))
	zj20=sn*zj17/(sn*zj18+4*sn*sb*zj12-zj19*zj3);
	//N22*(2*F22-2*E22+A22-B22)/(N22*(A22*A22-B22*B22-J22*J22)+4*N22*B22*(F22-E22)-(8*B22*(F22-E22)+2*(A22*A22-B22*B22))*ASIN(G22/B22))用
	zj21=sc*sc+sd*sd;
	//(C22*C22+D22*D22)
	zj22=Math.pow(zj21/2,0.5);
	zj23=(2*sc+2*sf-2*se-2*zj22)/(sc*sc-sd*sd+4*sc*sf-4*sc*se);
	//(2*C22+2*F22-2*E22-2*((C22*C22+D22*D22)/2)^0.5)/(C22*C22-D22*D22+4*C22*F22-4*C22*E22)用
	
	zjc1=zj4+zj14+zj16+zj20+zj23;
	
	
	
	//c2=2*E22/(N22/4*(A22*A22-B22*B22-J22*J22)-(A22*A22-B22*B22)/2*ASIN(G22/B22))^2+((B22-C22)/2+((B22*B22+C22*C22)/4-B22*C22/2*COS(ASIN(G22/B22)))^0.5)/B22/C22/((2*H22*G22+N22*(B22*B22-C22*C22)-2*B22*B22*ASIN(G22/B22))/(B22*B22-C22*C22)*(F22-E22))^2+32*E22/N22/N22/(C22*C22-D22*D22)^2+N22/8*(2*F22-2*E22+A22-B22)/(N22/8*(A22*A22-B22*B22-J22*J22)+2/4*B22*N22*(F22-E22)-(B22*(F22-E22)+(A22*A22-B22*B22)/4)*ASIN(G22/B22))^2+N22/4*(C22+F22-E22-((C22*C22+D22*D22)/2)^0.5)/((C22*C22-D22*D22)*N22/8+C22/2*N22*(F22-E22))^2
	zj24=sn/4*zj18-zj2/2*zj3;
	//(N22/4*(A22*A22-B22*B22-J22*J22)-(A22*A22-B22*B22)/2*ASIN(G22/B22))
	zj25=zj24*zj24;
	zj26=2*se/zj25;
	//2*E22/(N22/4*(A22*A22-B22*B22-J22*J22)-(A22*A22-B22*B22)/2*ASIN(G22/B22))^2 用
	zj27=zj8/4-sb*sc/2*zj9;
	//((B22*B22+C22*C22)/4-B22*C22/2*COS(ASIN(G22/B22)))^0.5
	zj28=Math.pow(zj27,0.5);
	zj29=(2*sh*sg+sn*zj13-2*sb*sb*zj3)/zj13*zj12;
	
	zj30=zj29*zj29;
	//((2*H22*G22+N22*(B22*B22-C22*C22)-2*B22*B22*ASIN(G22/B22))/(B22*B22-C22*C22)*(F22-E22))^2
	zj31=(zj6/2+zj28)/sb/sc/zj30
	//((B22-C22)/2+((B22*B22+C22*C22)/4-B22*C22/2*COS(ASIN(G22/B22)))^0.5)/B22/C22/((2*H22*G22+N22*(B22*B22-C22*C22)-2*B22*B22*ASIN(G22/B22))/(B22*B22-C22*C22)*(F22-E22))^2 用
	zj32=32*se/sn/sn/(zj15*zj15);
	//32*E22/N22/N22/(C22*C22-D22*D22)^2 用
	zj33=sb*zj12+zj2/4;
	//(B22*(F22-E22)+(A22*A22-B22*B22)/4)
	zj34=sn/8*zj1+2/4*sb*sn*zj12-zj33*zj3;
	zj35=zj34*zj34;
	//(N22/8*(A22*A22-B22*B22-J22*J22)+2/4*B22*N22*(F22-E22)-(B22*(F22-E22)+(A22*A22-B22*B22)/4)*ASIN(G22/B22))^2
	zj36=sn/8*zj17/zj35;
	//N22/8*(2*F22-2*E22+A22-B22)/(N22/8*(A22*A22-B22*B22-J22*J22)+2/4*B22*N22*(F22-E22)-(B22*(F22-E22)+(A22*A22-B22*B22)/4)*ASIN(G22/B22))^2用
	zj37=Math.pow(zj21/2,0.5);
	//((C22*C22+D22*D22)/2)^0.5
	zj38=zj15*sn/8+sc/2*sn*zj12;
	zj39=zj38*zj38;
	//((C22*C22-D22*D22)*N22/8+C22/2*N22*(F22-E22))^2
	zj40=sn/4*(sc+sf-se-zj37)/zj39;
	//N22/4*(C22+F22-E22-((C22*C22+D22*D22)/2)^0.5)/((C22*C22-D22*D22)*N22/8+C22/2*N22*(F22-E22))^2 用
	
	zjc2=zj26+zj31+zj32+zj36+zj40;
	
	
	
	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	
	
	
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
	
	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
}


export function acaluf(za,zb,zc,zd,ze,zf){
	sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sn = 3.14159265358979;
	zj1 = 4*se;
	zj2 = sc*sn;
	zj3 = sf-se;
	zj4 = zj1+zj2;
	zj5 = zj4/sc/sd;
	zj6 = 2*sb/zj3/sd;
	zjc1 = zj5+zj6; //C1
	//c2=4*E9/C9/C9/D9/D9+2*B9/(F9-E9)^2/D9/D9+2*N9/(F9-E9+C9)/D9/D9
	zj8 = 4*se/sc/sc/sd/sd; //4*E9/C9/C9/D9/D9
	zj9 = sf-se;    //(F9-E9)
	zj10 = zj9*zj9;   //(F9-E9)^2
	zj11 = 2*sb/zj10/sd/sd;     
	//2*B9/(F9-E9)^2/D9/D9
	zj12 = sf-se+sc;   //(F9-E9+C9)
	zj13 =2*sn/zj12/sd/sd;  
	//2*N9/(F9-E9+C9)/D9/D9
	zjc2 = zj8+zj11+zj13;   //c2
	zjae = zjc1/zjc2;  
	 //ae 
	zjle = zjc1*zjc1/zjc2; 
	 //le
	 zjve =zjc1*zjc1*zjc1/zjc2/zjc2;
	 //ve
	 
	
	 
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
	
	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
	
}


export function acalui(za,zb,zc,zd,ze,zf,zg){
	
	 sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	sn = 3.14159265358979;
    //c1=B10*(F10-E10+G10)/D10/G10/(F10-E10)+(2*E10+C10*N10)/C10/D10
	zj1=sf-se+sg;   //(F10-E10+G10)
	zj2=sf-se;      //(F10-E10)
	zj3=2*se+sc*sn;  //(2*E10+C10*N10)
	zjc1=sb*zj1/sd/sg/zj2+(zj3/sc/sd);
	//c2=B10*((F10-E10)^2+G10^2)/D10^2/G10^2/(F10-E10)^2+N10*(F10-E10+G10+2*C10)/D10^2/(G10+C10)/(F10-E10+C10)+2*E10/C10^2/D10^2
	 zj4=sf-se+sg+2*sc;  //(F10-E10+G10+2*C10)
	 zj5=sg+sc;           //(G10+C10)
	 zj6=sf-se+sc;      //(F10-E10+C10)
	 zj7=zj2*zj2+sg*sg;   //((F10-E10)^2+G10^2)
	 zj8=sb*zj7/(sd*sd)/(sg*sg)/(zj2*zj2);   
	 //B10*((F10-E10)^2+G10^2)/D10^2/G10^2/(F10-E10)^2用
	 zj9=sn*zj4/(sd*sd)/zj5/zj6;
	 //N10*(F10-E10+G10+2*C10)/D10^2/(G10+C10)/(F10-E10+C10)用
	 zj10=2*se/(sc*sc)/(sd*sd);
	 //2*E10/C10^2/D10^2  用
	 zjc2=zj8+zj9+zj10
	
	
	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	
	
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
}


export function acaluyf(za,zb,zc,zd,ze,zf){
	sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sn = 3.14159265358979;
	 zj1=sc*sc+sd*sd;      //(C11^2+D11^2)
   zj2=sf-se;            //(F11-E11)
   zj3=sd+sf-se;        //(D11+F11-E11)
	zj4=sn*sd*sd+4*sf*sc-4*sc*se;  //(N11*D11^2+4*F11*C11-4*C11*E11)
   zj5=sf-se+sc;     //(F11-E11+C11)
	zj6=sn*sc*sc+4*sf*sc-4*se*sc;    //(N11*C11^2+4*F11*C11-4*E11*C11)
	zj7=8*se*zj1/sn/(sc*sc)/(sd*sd);       
	//8*E11*(C11^2+D11^2)/N11/C11^2/D11^2用
	zj8=2*sb/zj2/sc
	//2*B11/(F11-E11)/C11用
	zj9=2*sn*zj3/zj4;
	//2*N11*(D11+F11-E11)/(N11*D11^2+4*F11*C11-4*C11*E11)用
	zj10=2*sn*zj5/zj6;
	//2*N11*(F11-E11+C11)/(N11*C11^2+4*F11*C11-4*E11*C11) 用
	zjc1=zj7+zj8+zj9+zj10;
	
	zj11=sd*sd*sd*sd+sc*sc*sc*sc;   //(D11^4+C11^4)
	zj12=sf-se+sd;     //(F11-E11+D11)
	zj13=sn/4*sd*sd+zj2*sc;
	   //(N11/4*D11^2+(F11-E11)*C11)
	   zj23=sn/4*sc*sc+zj2*sc;
	   //(N11/4*C11^2+(F11-E11)*C11)
	zj14=32*se*zj11/(sn*sn)/(sd*sd*sd*sd)/(sc*sc*sc*sc);
	//32*E11*(D11^4+C11^4)/N11^2/D11^4/C11^4 用
	zj15=2*sb/(zj2*zj2)/(sc*sc);
	//2*B11/(F11-E11)^2/C11^2  用
	zj16=sn*zj12/(zj13*zj13);
	//N11*(F11-E11+D11)/(N11/4*D11^2+(F11-E11)*C11)^2用
	zj17=sn*zj5/(zj23*zj23);
	//N11*(F11-E11+C11)/(N11/4*C11^2+(F11-E11)*C11)^2用
	
	zjc2=zj14+zj15+zj16+zj17;
	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
}




export function acalefd(za,zb,zk,zc,zd,zl,ze,zf,zh){
	 sa = parseFloat(za);
    sb = parseFloat(zb);
	sk = parseFloat(zk);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	sl = parseFloat(zl);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sh = parseFloat(zh);
	
	
	sn = 3.14159265358979;
//c1=E24/L24/(A24-B24)*2+(B24-C24)/2/(L24-H24)/(F24-E24)+E24/C24/D24*2+N24*((A24-B24)/2+F24-E24)/8/((L24-H24)*(F24-E24)/2+(A24-B24)*L24/4)+((N24*(F24-E24+C24/2)/8)^2+(L24-D24)^2/4)^0.5/((F24-E24)*(L24-H24)/2+C24*D24/4)
     zj1=sa-sb;  //(A24-B24)
	 zj2=sb-sc;//(B24-C24)
	 zj3=sl-sh;//(L24-H24)
	 zj4=sf-se;//(F24-E24)
	
	 //E24/L24/(A24-B24)*2  用下
	 zj5=se/sl/zj1*2;
	 //(B24-C24)/2/(L24-H24)/(F24-E24)用下
	 zj6=zj2/2/zj3/zj4;
	 //E24/C24/D24*2   用下
	 zj7=se/sc/sd*2;
	 //N24*((A24-B24)/2+F24-E24)/8/((L24-H24)*(F24-E24)/2+(A24-B24)*L24/4) 用下
	 zj8=sn*(zj1/2+sf-se)/8/(zj3*zj4/2+zj1*sl/4);
	 //((N24*(F24-E24+C24/2)/8)^2+(L24-D24)^2/4)^0.5/((F24-E24)*(L24-H24)/2+C24*D24/4)
	 zj9=sl-sd;
	 zj10=sf-se+sc/2;
	 zj11=sn*zj10/8;
	 zj12=zj11*zj11+zj9*zj9/4;
	 zj13=Math.pow(zj12,0.5);
     zj14=zj13/(zj4*zj3/2+sc*sd/4);
	
	 //用上
	 zjc1=zj5+zj6+zj7+zj8+zj14;
	
	 
	 
//c2=E24/(L24*(A24-B24)/2)^2/2+(B24-C24)/2/((L24-H24)*(F24-E24))^2/2+E24/(C24*D24/2)^2/2+N24*((A24-B24)/2+F24-E24)/8/((L24-H24)*(F24-E24)/2+(A24-B24)*L24/4)^2/2+((N24*(F24-E24+C24/2)/8)^2+(L24-D24)^2/4)^0.5/((F24-E24)*(L24-H24)/2+C24*D24/4)^2/2
	
	//E24/(L24*(A24-B24)/2)^2/2 用
	zj15=sl*zj1/2;
	zj16=se/(zj15*zj15)/2;  
	 //用zj16
	//(B24-C24)/2/((L24-H24)*(F24-E24))^2/2 用
	zj17=zj3*zj4;
	zj18=zj2/2/(zj17*zj17)/2;    
	//用zj18
	//E24/(C24*D24/2)^2/2 用
	zj19=sc*sd/2;
	zj20=se/(zj19*zj19)/2;
	//用zj20
	
	//N24*((A24-B24)/2+F24-E24)/8/((L24-H24)*(F24-E24)/2+(A24-B24)*L24/4)^2/2 用
	zj21=zj1/2+sf-se;
	zj22=zj3*zj4/2+zj1*sl/4;
	zj23=sn*zj21/8/(zj22*zj22)/2;
	//用zj23
	
	//((N24*(F24-E24+C24/2)/8)^2+(L24-D24)^2/4)^0.5/((F24-E24)*(L24-H24)/2+C24*D24/4)^2/2用
	zj24=sf-se+sc/2;
	zj25=sn*zj24/8;
	zj26=sl-sd;
	zj27=(zj25*zj25)+(zj26*zj26)/4;
	zj28=Math.pow(zj27,0.5);
	zj29=zj4*zj3/2+(sc*sd)/4;
	zj30=zj28/(zj29*zj29)/2;
	//用zj30
	zjc2=zj16+zj18+zj20+zj23+zj30;
	
	
	
	
	
	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	
	
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
}


export function acalrma(za,zb,zc,zd,ze,zf,zg,zh,zi,zj){
	 sa = parseFloat(za);
    sb = parseFloat(zb);
	
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	sh = parseFloat(zh);
	si = parseFloat(zi);
	sj = parseFloat(zj);

   
	
	sn = 3.14159265358979;
	
	//c1=2*E27/(A27*A27/2+A27*A27*TAN(ACOS(J27/B27)-N27/4)/2-B27*B27*ACOS(J27/B27)/2-I27*I27/2)+(B27+C27)*LN(B27/C27)*(2*B27-C27-B27*H27/J27/TAN(ACOS(J27/B27))+H27/TAN(ACOS(J27/B27)))/(2*(F27-E27)*(2*B27*B27*ACOS(J27/B27)+2*H27*H27/TAN(ACOS(J27/B27))-N27*C27*C27))+2*E27/(N27*(C27*C27-D27*D27)/4)+N27*(F27-E27+A27/2-B27/2)/4/(A27*A27/4+A27*A27/4*TAN(ACOS(J27/B27)-N27/4)-B27*B27/4*ACOS(J27/B27)-I27*I27/4+B27*(F27-E27)*ACOS(J27/B27))+N27/4*(C27+F27-E27-((C27*C27+D27*D27)/2)^0.5)/(N27/8*(C27*C27-D27*D27)+C27*N27*(F27-E27)/2)
	zx1=sj/sb;
	  //(J27/B27)
	zx2=Math.acos(zx1);  //ACOS(J27/B27)
	zx3=Math.tan(zx2);   //TAN(ACOS(J27/B27))
	zx4=Math.log(sb/sc);  
	 //LN(B27/C27)
	 zx5=sc*sc-sd*sd;   // (C27*C27-D27*D27)  rm2用
	  zx55=sc*sc+sd*sd;                 // (C27*C27+D27*D27)  rm2用
	 zx6=sa*sa;
	 zx7=Math.tan(zx2-sn/4);    
	   //TAN(ACOS(J27/B27)-N27/4)
	  zx9=sb+sc;//(B27+C27)
	  zx10=sf-se;//(F27-E27)
	//2*E27/(A27*A27/2+A27*A27*TAN(ACOS(J27/B27)-N27/4)/2-B27*B27*ACOS(J27/B27)/2-I27*I27/2)  用
	zx8=2*se/(zx6/2+zx6*zx7/2-sb*sb*zx2/2-si*si/2);
	//用zx8
	//(B27+C27)*LN(B27/C27)*(2*B27-C27-B27*H27/J27/TAN(ACOS(J27/B27))+H27/TAN(ACOS(J27/B27)))/(2*(F27-E27)*(2*B27*B27*ACOS(J27/B27)+2*H27*H27/TAN(ACOS(J27/B27))-N27*C27*C27))用
	
	zx11=zx9*zx4*(2*sb-sc-sb*sh/sj/zx3+sh/zx3)/(2*zx10*(2*sb*sb*zx2+2*sh*sh/zx3-sn*sc*sc));
	//用zx11
	
	
	
	//2*E27/(N27*(C27*C27-D27*D27)/4)  用
	zx12=2*se/(sn*zx5/4);
	//用zx12
	//N27*(F27-E27+A27/2-B27/2)/4/(A27*A27/4+A27*A27/4*TAN(ACOS(J27/B27)-N27/4)-B27*B27/4*ACOS(J27/B27)-I27*I27/4+B27*(F27-E27)*ACOS(J27/B27))用
	zx13=sn*(sf-se+sa/2-sb/2)/4/(sa*sa/4+sa*sa/4*zx7-sb*sb/4*zx2-si*si/4+sb*zx10*zx2);
	//用zx13
	
	
	//N27/4*(C27+F27-E27-((C27*C27+D27*D27)/2)^0.5)/(N27/8*(C27*C27-D27*D27)+C27*N27*(F27-E27)/2)用
	zx14=Math.pow(zx55/2,0.5);   //((C27*C27+D27*D27)/2)^0.5
	zx15=sn/4*(sc+sf-se-zx14)/(sn/8*zx5+sc*sn*zx10/2);
	
	//用zx15
	zjc1=zx8+zx11+zx12+zx13+zx15;
	
	
	
	//c2=2*E27/(A27*A27/2+A27*A27*TAN(ACOS(J27/B27)-N27/4)/2-B27*B27*ACOS(J27/B27)/2-I27*I27/2)^2+(2*B27-C27-B27*H27/J27/TAN(ACOS(J27/B27))+H27/TAN(ACOS(J27/B27)))/2/B27/C27/(F27-E27)^2/((2*B27*B27*ACOS(J27/B27)+2*H27*H27/TAN(ACOS(J27/B27))-N27*C27*C27)/(B27*B27-C27*C27))^2+2*E27/(N27*(C27*C27-D27*D27)/4)^2+N27*(F27-E27+A27/2-B27/2)/4/(A27*A27/4+A27*A27/4*TAN(ACOS(J27/B27)-N27/4)-B27*B27/4*ACOS(J27/B27)-I27*I27/4+B27*(F27-E27)*ACOS(J27/B27))^2+N27/4*(C27+F27-E27-((C27*C27+D27*D27)/2)^0.5)/(N27/8*(C27*C27-D27*D27)+C27*N27*(F27-E27)/2)^2
	
	//2*E27/(A27*A27/2+A27*A27*TAN(ACOS(J27/B27)-N27/4)/2-B27*B27*ACOS(J27/B27)/2-I27*I27/2)^2  用
	zx16=(sa*sa/2+sa*sa*zx7/2-sb*sb*zx2/2-si*si/2);
	//(A27*A27/2+A27*A27*TAN(ACOS(J27/B27)-N27/4)/2-B27*B27*ACOS(J27/B27)/2-I27*I27/2)
	zx17=2*se/(zx16*zx16);
	//用zx17
	//(2*B27-C27-B27*H27/J27/TAN(ACOS(J27/B27))+H27/TAN(ACOS(J27/B27)))/2/B27/C27/(F27-E27)^2/((2*B27*B27*ACOS(J27/B27)+2*H27*H27/TAN(ACOS(J27/B27))-N27*C27*C27)/(B27*B27-C27*C27))^2  用
	zx18=2*sb-sc-sb*sh/sj/zx3+sh/zx3;
	//(2*B27-C27-B27*H27/J27/TAN(ACOS(J27/B27))+H27/TAN(ACOS(J27/B27)))
	zx19=(2*sb*sb*zx2+2*sh*sh/zx3-sn*sc*sc)/(sb*sb-sc*sc);
	zx20=zx19*zx19;
	zx21=zx18/2/sb/sc/(zx10*zx10)/zx20;
	//用 zx21
	
	//2*E27/(N27*(C27*C27-D27*D27)/4)^2  用
	zx22=sn*zx5/4;  
	//(N27*(C27*C27-D27*D27)/4)
	zx23=zx22*zx22;
	zx24=2*se/zx23;
	//用 zx24
	
	//N27*(F27-E27+A27/2-B27/2)/4/(A27*A27/4+A27*A27/4*TAN(ACOS(J27/B27)-N27/4)-B27*B27/4*ACOS(J27/B27)-I27*I27/4+B27*(F27-E27)*ACOS(J27/B27))^2  用
	zx25=sf-se+sa/2-sb/2;
	//(F27-E27+A27/2-B27/2)
	
	zx26=sa*sa/4+sa*sa/4*zx7-sb*sb/4*zx2-si*si/4+sb*zx10*zx2;
	//(A27*A27/4+A27*A27/4*TAN(ACOS(J27/B27)-N27/4)-B27*B27/4*ACOS(J27/B27)-I27*I27/4+B27*(F27-E27)*ACOS(J27/B27))
	zx27=zx26*zx26;
	zx28=sn*zx25/4/zx27;
	//用 zx28
	
	//N27/4*(C27+F27-E27-((C27*C27+D27*D27)/2)^0.5)/(N27/8*(C27*C27-D27*D27)+C27*N27*(F27-E27)/2)^2  用
	zx29=sn/8*zx5+sc*sn*zx10/2;
	//(N27/8*(C27*C27-D27*D27)+C27*N27*(F27-E27)/2)
	zx30=zx29*zx29;
	zx31=sn/4*(sc+sf-se-zx14)/zx30;
	//用  zx31
	
	zjc2=zx17+zx21+zx24+zx28+zx31;
	
	
	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	
	
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
}


export function acalrmb(za,zb,zc,zd,ze,zf,zg,zh,zi,zj){
	
    sa = parseFloat(za);
    sb = parseFloat(zb);
	
	sc = parseFloat(zc);
	//sd = parseFloat(zd);
	
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	sh = parseFloat(zh);
	si = parseFloat(zi);
	sj = parseFloat(zj);
     
   
	
	sn = 3.14159265358979;
	
	//c1==2*E28/(A28*A28/2+A28*A28*TAN(ACOS(J28/B28)-N28/4)/2-B28*B28*ACOS(J28/B28)/2-I28*I28/2)+(B28+C28)*LN(B28/C28)*(2*B28-C28-B28*H28/J28/TAN(ACOS(J28/B28))+H28/TAN(ACOS(J28/B28)))/(2*(F28-E28)*(2*B28*B28*ACOS(J28/B28)+2*H28*H28/TAN(ACOS(J28/B28))-N28*C28*C28))+2*E28/(N28*C28*C28/4)+N28*(F28-E28+A28/2-B28/2)/4/(A28*A28/4+A28*A28/4*TAN(ACOS(J28/B28)-N28/4)-B28*B28/4*ACOS(J28/B28)-I28*I28/4+B28*(F28-E28)*ACOS(J28/B28))+N28/4*(0.298*C28+F28-E28)/(N28/8*C28*C28+C28*N28*(F28-E28)/2)
	zx1=sj/sb;
	  //(J27/B27)
	zx2=Math.acos(zx1);  //ACOS(J27/B27)
	zx3=Math.tan(zx2);   //TAN(ACOS(J27/B27))
	zx4=Math.log(sb/sc);  
	 //LN(B27/C27)
	 zx5=sc*sc;   // (C27*C27)  rm2用
	  zx55=sc*sc;                 // (C27*C27)  rm2用
	 zx6=sa*sa;
	 zx7=Math.tan(zx2-sn/4);    
	   //TAN(ACOS(J27/B27)-N27/4)
	  zx9=sb+sc;//(B27+C27)
	  zx10=sf-se;//(F27-E27)
	//2*E27/(A27*A27/2+A27*A27*TAN(ACOS(J27/B27)-N27/4)/2-B27*B27*ACOS(J27/B27)/2-I27*I27/2)  用
	zx8=2*se/(zx6/2+zx6*zx7/2-sb*sb*zx2/2-si*si/2);
	//用zx8
	//(B27+C27)*LN(B27/C27)*(2*B27-C27-B27*H27/J27/TAN(ACOS(J27/B27))+H27/TAN(ACOS(J27/B27)))/(2*(F27-E27)*(2*B27*B27*ACOS(J27/B27)+2*H27*H27/TAN(ACOS(J27/B27))-N27*C27*C27))用
	
	zx11=zx9*zx4*(2*sb-sc-sb*sh/sj/zx3+sh/zx3)/(2*zx10*(2*sb*sb*zx2+2*sh*sh/zx3-sn*sc*sc));
	//用zx11
	
	
	
	//2*E27/(N27*(C27*C27-D27*D27)/4)  用
	zx12=2*se/(sn*zx5/4);
	//用zx12
	//N27*(F27-E27+A27/2-B27/2)/4/(A27*A27/4+A27*A27/4*TAN(ACOS(J27/B27)-N27/4)-B27*B27/4*ACOS(J27/B27)-I27*I27/4+B27*(F27-E27)*ACOS(J27/B27))用
	zx13=sn*(sf-se+sa/2-sb/2)/4/(sa*sa/4+sa*sa/4*zx7-sb*sb/4*zx2-si*si/4+sb*zx10*zx2);
	//用zx13
	
	
	//N28/4*(0.298*C28+F28-E28)/(N28/8*C28*C28+C28*N28*(F28-E28)/2)用
	
	zx15=sn/4*(0.298*sc+sf-se)/(sn/8*zx5+sc*sn*zx10/2);
	
	//用zx15
	zjc1=zx8+zx11+zx12+zx13+zx15;
	
	
	
	//c2==2*E28/(A28*A28/2+A28*A28*TAN(ACOS(J28/B28)-N28/4)/2-B28*B28*ACOS(J28/B28)/2-I28*I28/2)^2+(2*B28-C28-B28*H28/J28/TAN(ACOS(J28/B28))+H28/TAN(ACOS(J28/B28)))/2/B28/C28/(F28-E28)^2/((2*B28*B28*ACOS(J28/B28)+2*H28*H28/TAN(ACOS(J28/B28))-N28*C28*C28)/(B28*B28-C28*C28))^2+2*E28/(N28*C28*C28/4)^2+N28*(F28-E28+A28/2-B28/2)/4/(A28*A28/4+A28*A28/4*TAN(ACOS(J28/B28)-N28/4)-B28*B28/4*ACOS(J28/B28)-I28*I28/4+B28*(F28-E28)*ACOS(J28/B28))^2+N28/4*(0.298*C28+F28-E28)/(N28/8*C28*C28+C28*N28*(F28-E28)/2)^2
	
	
	//2*E27/(A27*A27/2+A27*A27*TAN(ACOS(J27/B27)-N27/4)/2-B27*B27*ACOS(J27/B27)/2-I27*I27/2)^2  用
	zx16=(sa*sa/2+sa*sa*zx7/2-sb*sb*zx2/2-si*si/2);
	//(A27*A27/2+A27*A27*TAN(ACOS(J27/B27)-N27/4)/2-B27*B27*ACOS(J27/B27)/2-I27*I27/2)
	zx17=2*se/(zx16*zx16);
	//用zx17
	//(2*B27-C27-B27*H27/J27/TAN(ACOS(J27/B27))+H27/TAN(ACOS(J27/B27)))/2/B27/C27/(F27-E27)^2/((2*B27*B27*ACOS(J27/B27)+2*H27*H27/TAN(ACOS(J27/B27))-N27*C27*C27)/(B27*B27-C27*C27))^2  用
	zx18=2*sb-sc-sb*sh/sj/zx3+sh/zx3;
	//(2*B27-C27-B27*H27/J27/TAN(ACOS(J27/B27))+H27/TAN(ACOS(J27/B27)))
	zx19=(2*sb*sb*zx2+2*sh*sh/zx3-sn*sc*sc)/(sb*sb-sc*sc);
	zx20=zx19*zx19;
	zx21=zx18/2/sb/sc/(zx10*zx10)/zx20;
	//用 zx21
	
	//2*E27/(N27*(C27*C27-D27*D27)/4)^2  用
	zx22=sn*zx5/4;  
	//(N27*(C27*C27-D27*D27)/4)
	zx23=zx22*zx22;
	zx24=2*se/zx23;
	//用 zx24
	
	//N27*(F27-E27+A27/2-B27/2)/4/(A27*A27/4+A27*A27/4*TAN(ACOS(J27/B27)-N27/4)-B27*B27/4*ACOS(J27/B27)-I27*I27/4+B27*(F27-E27)*ACOS(J27/B27))^2  用
	zx25=sf-se+sa/2-sb/2;
	//(F27-E27+A27/2-B27/2)
	
	zx26=sa*sa/4+sa*sa/4*zx7-sb*sb/4*zx2-si*si/4+sb*zx10*zx2;
	//(A27*A27/4+A27*A27/4*TAN(ACOS(J27/B27)-N27/4)-B27*B27/4*ACOS(J27/B27)-I27*I27/4+B27*(F27-E27)*ACOS(J27/B27))
	zx27=zx26*zx26;
	zx28=sn*zx25/4/zx27;
	//用 zx28
	
	//N28/4*(0.298*C28+F28-E28)/(N28/8*C28*C28+C28*N28*(F28-E28)/2)^2  用
	zx29=sn/8*zx5+sc*sn*zx10/2;
	//(N27/8*(C27*C27-D27*D27)+C27*N27*(F27-E27)/2)
	zx30=zx29*zx29;
	zx31=sn/4*(0.298*sc+sf-se)/zx30;
	//用  zx31
	
	zjc2=zx17+zx21+zx24+zx28+zx31;
	
	
	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	
	
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
	
	
	
	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
}

export function acalpq(za,zb,zc,zd,ze,zf,zg,zh){
	sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	sh = parseFloat(zh);
	
	
	sn = 3.14159265358979;
	
	//c1=2*E23/(D23*(A23-G23)-B23*B23/2*ACOS(G23/B23)+B23*G23/2*SIN(ACOS(G23/B23)))+(B23+C23)*LN(B23/C23)/(F23-E23)*((B23-C23)/2+(B23*B23/4+C23*C23/4-B23*C23/2*COS(N23/2-ACOS(G23/B23)-ASIN(H23/C23)))^0.5)/(2*B23*B23*ACOS(G23/B23)+2*B23*C23*SIN(N23/2-ACOS(G23/B23)-ASIN(H23/C23))-2*C23*C23*(N23/2-ASIN(H23/C23)))+2*E23/N23/C23/C23*4+N23/4*(F23-E23+A23/2-B23/2)/(A23*D23/2-D23*G23/2+B23*G23/4*SIN(ACOS(G23/B23))+(B23*F23-B23*E23-B23*B23/4)*ACOS(G23/B23))+N23/4*(F23-E23+0.298*C23)/(N23*C23*C23/8+C23*(F23-E23)*(N23/2-ASIN(H23/C23)))
	zj1=sa-sg;   //(A23-G23)
	zj2=Math.acos(sg/sb);     
	//ACOS(G23/B23)
	zj3=sb+sc;  //(B23+C23)
	zj4=sb-sc;//(B23-C23)
	zj5=sf-se;  //(F23-E23)
    zj6= Math.log(sb/sc);
	        //LN(B23/C23)
			
	zj7=Math.sin(zj2);
	//SIN(ACOS(G23/B23))
	
	zj8=sb-sc;//(B23-C23)
	//2*E23/(D23*(A23-G23)-B23*B23/2*ACOS(G23/B23)+B23*G23/2*SIN(ACOS(G23/B23)))用
	zj9=2*se/(sd*zj1-sb*sb/2*zj2+sb*sg/2*zj7);
	//用 zj9
	
	//(B23+C23)*LN(B23/C23)/(F23-E23)*((B23-C23)/2+(B23*B23/4+C23*C23/4-B23*C23/2*COS(N23/2-ACOS(G23/B23)-ASIN(H23/C23)))^0.5)/(2*B23*B23*ACOS(G23/B23)+2*B23*C23*SIN(N23/2-ACOS(G23/B23)-ASIN(H23/C23))-2*C23*C23*(N23/2-ASIN(H23/C23))) 用
	zj10=Math.asin(sh/sc);
	//ASIN(H23/C23)
	zj11=sn/2-zj2-zj10;
	//(N23/2-ACOS(G23/B23)-ASIN(H23/C23))
	zj12=Math.cos(zj11);
	//COS(N23/2-ACOS(G23/B23)-ASIN(H23/C23))
	zj13=sb*sb/4+sc*sc/4-sb*sc/2*zj12;
	zj14=Math.pow(zj13,0.5);
	//(B23*B23/4+C23*C23/4-B23*C23/2*COS(N23/2-ACOS(G23/B23)-ASIN(H23/C23)))^0.5)
	zj15=Math.sin(sn/2-zj2-zj10);
	//SIN(N23/2-ACOS(G23/B23)-ASIN(H23/C23))
	zj16=zj3*zj6/zj5*(zj8/2+zj14)/(2*sb*sb*zj2+2*sb*sc*zj15-2*sc*sc*(sn/2-zj10));
	//用 zj16
	
	
	
	
	//2*E23/N23/C23/C23*4  用
	zj17=2*se/sn/sc/sc*4;
	//用zj17
	
	//N23/4*(F23-E23+A23/2-B23/2)/(A23*D23/2-D23*G23/2+B23*G23/4*SIN(ACOS(G23/B23))+(B23*F23-B23*E23-B23*B23/4)*ACOS(G23/B23))  用
zj18=sn/4*(sf-se+sa/2-sb/2)/(sa*sd/2-sd*sg/2+sb*sg/4*zj7+(sb*sf-sb*se-sb*sb/4)*zj2);
	//用zj18
	
	
//+N23/4*(F23-E23+0.298*C23)/(N23*C23*C23/8+C23*(F23-E23)*(N23/2-ASIN(H23/C23)))用
	zj19=sn/4*(sf-se+0.298*sc)/(sn*sc*sc/8+sc*zj5*(sn/2-zj10));
	//用zj19
	
	zjc1=zj9+zj16+zj17+zj18+zj19;
	
	
	
	
	
	
	
	//c2=2*E23/(D23*(A23-G23)-B23*B23/2*ACOS(G23/B23)+B23*G23/2*SIN(ACOS(G23/B23)))^2+((B23-C23)/2+(B23*B23/4+C23*C23/4-B23*C23/2*COS(N23/2-ACOS(G23/B23)-ASIN(H23/C23)))^0.5)/B23/C23/((2*B23*B23*ACOS(G23/B23)+2*B23*C23*SIN(N23/2-ACOS(G23/B23)-ASIN(H23/C23))-2*C23*C23*(N23/2-ASIN(H23/C23)))*(F23-E23)/(B23*B23-C23*C23))^2+2*E23/(N23*C23*C23/4)^2+N23/4*(F23-E23+A23/2-B23/2)/(A23*D23/2-D23*G23/2+B23*G23/4*SIN(ACOS(G23/B23))+(B23*F23-B23*E23-B23*B23/4)*ACOS(G23/B23))^2+N23/4*(F23-E23+0.298*C23)/(N23*C23*C23/8+C23*(F23-E23)*(N23/2-ASIN(H23/C23)))^2
	//开始
	//2*E23/(D23*(A23-G23)-B23*B23/2*ACOS(G23/B23)+B23*G23/2*SIN(ACOS(G23/B23)))^2用
	zj20=sd*zj1-sb*sb/2*zj2+sb*sg/2*zj7;
	zj21=zj20*zj20;
	zj22=2*se/zj21;
	//用 zj22
	
	
	//((B23-C23)/2+(B23*B23/4+C23*C23/4-B23*C23/2*COS(N23/2-ACOS(G23/B23)-ASIN(H23/C23)))^0.5)/B23/C23/((2*B23*B23*ACOS(G23/B23)+2*B23*C23*SIN(N23/2-ACOS(G23/B23)-ASIN(H23/C23))-2*C23*C23*(N23/2-ASIN(H23/C23)))*(F23-E23)/(B23*B23-C23*C23))^2 用
	zj23=Math.cos(sn/2-zj2-zj10);
	//COS(N23/2-ACOS(G23/B23)-ASIN(H23/C23))
	zj24=sb*sb/4+sc*sc/4-sb*sc/2*zj23;
	zj25=Math.pow(zj24,0.5);
	//(B23*B23/4+C23*C23/4-B23*C23/2*COS(N23/2-ACOS(G23/B23)-ASIN(H23/C23)))^0.5
	zj26=zj4/2+zj25;
	//((B23-C23)/2+(B23*B23/4+C23*C23/4-B23*C23/2*COS(N23/2-ACOS(G23/B23)-ASIN(H23/C23)))^0.5)
	zj27=Math.sin(sn/2-zj2-zj10);
	//SIN(N23/2-ACOS(G23/B23)-ASIN(H23/C23))
	zj28=sb*sb-sc*sc;//(B23*B23-C23*C23)
	zj29=sn/2-zj10;
	//(N23/2-ASIN(H23/C23))
	zj30=(2*sb*sb*zj2+2*sb*sc*zj27-2*sc*sc*zj29)*zj5/zj28;
	zj31=zj30*zj30;
	//((2*B23*B23*ACOS(G23/B23)+2*B23*C23*SIN(N23/2-ACOS(G23/B23)-ASIN(H23/C23))-2*C23*C23*(N23/2-ASIN(H23/C23)))*(F23-E23)/(B23*B23-C23*C23))^2
	zj32=zj26/sb/sc/zj31;
	//用zj32
	
	//2*E23/(N23*C23*C23/4)^2 用
	zj33=sn*sc*sc/4;
	zj34=zj33*zj33;
	zj35=2*se/zj34;
	//用 zj35
	
	//N23/4*(F23-E23+A23/2-B23/2)/(A23*D23/2-D23*G23/2+B23*G23/4*SIN(ACOS(G23/B23))+(B23*F23-B23*E23-B23*B23/4)*ACOS(G23/B23))^2  用
	zj36=sb*sf-sb*se-sb*sb/4;
	//(B23*F23-B23*E23-B23*B23/4)
	zj37=sa*sd/2-sd*sg/2+sb*sg/4*zj7+zj36*zj2;
	zj38=zj37*zj37;
	//(A23*D23/2-D23*G23/2+B23*G23/4*SIN(ACOS(G23/B23))+(B23*F23-B23*E23-B23*B23/4)*ACOS(G23/B23))^2 
	zj39=sn/4*(sf-se+sa/2-sb/2)/zj38;
	//用 zj39
	//N23/4*(F23-E23+0.298*C23)/(N23*C23*C23/8+C23*(F23-E23)*(N23/2-ASIN(H23/C23)))^2用
	zj40=sn*sc*sc/8+sc*zj5*(sn/2-zj10);
	zj41=zj40*zj40;
	//(N23*C23*C23/8+C23*(F23-E23)*(N23/2-ASIN(H23/C23)))^2
	zj42=sn/4*(sf-se+0.298*sc)/zj41;
	//用 zj42
	
	zjc2=zj22+zj32+zj35+zj39+zj42;
	
	
	
	
	
	
	zjae=zjc1/zjc2;
	zjle=zjc1*zjc1/zjc2;
	zjve=zjc1*zjc1*zjc1/zjc2/zjc2;
	
	
	c1 = +zjc1.toFixed(6);
	c2 = +zjc2.toFixed(8);
	ae = +zjae.toFixed(4);
	le = +zjle.toFixed(4);
	ve = +zjve.toFixed(4);
	
	return {C1:c1,C2:c2,Ae:ae,Le:le,Ve:ve}
}




export function bcalo(za,zb,zc)
{
   

    sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	 vva=(sa/2*sa/2*3.14-sb/2*sb/2*3.14)*sc;
	va = +vva.toFixed(6);
	return va
}

export function bcalee(za,zb,zc,zd,ze,zf)
{
    sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	 sd = parseFloat(zd);
    se = parseFloat(ze);
	sf = parseFloat(zf);
	
	vva=(sa*2*sf-(sb-sc)*2*se)*sd; 
	
	va = +vva.toFixed(6);
	return va
}

export function bcaluf(za,zb,zc,zd,ze,zf)
{
    sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	 sd = parseFloat(zd);
    se = parseFloat(ze);
	sf = parseFloat(zf);
	
	vva=(sa*sf-sb*se)*sd*2
	
	va = +vva.toFixed(6);
	return va
}

export function bcalui(za,zb,zc,zd,ze,zf,zg)
{
    sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	 sd = parseFloat(zd);
    se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	
	vva=((sa*sf-sb*se)+(sa*sg))*sd;
	
	va = +vva.toFixed(6);
	return va
}


export function bcaluyf(za,zb,zc,zd,ze,zf)
{
    sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	 sd = parseFloat(zd);
    se = parseFloat(ze);
	sf = parseFloat(zf);
	
	
	vva=((sc/2*sc/2)*3.14*se*2+(sa*sd*(sf-se)))*2;
	
	va = +vva.toFixed(6);
	return va
}


export function bcalei(za,zb,zc,zd,ze,zf,zg)
{
    sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	 sd = parseFloat(zd);
    se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	
	
	vva=(sa*sf-(sb-sc)*se+sa*sg)*sd;
	
	va = +vva.toFixed(6);
	return va
}



export function bcalec(za,zb,zc,zd,ze,zf)
{
    sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	 sd = parseFloat(zd);
    se = parseFloat(ze);
	sf = parseFloat(zf);
	
	
	
	vva=((sc/2*sc/2)*3.14*se+(sa-sb)*sd*se+(sa*sd*(sf-se)))*2;
	
	va = +vva.toFixed(6);
	return va
}


export function bcaleed(za,zb,zc,zd,ze,zf,zg)
{
    sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	 sd = parseFloat(zd);
    se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	
	
	
	vva=((sc*sg+(sd-sg)/2*(sd-sg)/2*3.14*se)+(sa-sb)*sd*se+sa*(sf-se)*sd)*2;
	
	va = +vva.toFixed(6);
	return va
}


export function bcalft(za,zb,zc,zd,ze,zf)
{
    sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	 sd = parseFloat(zd);
    se = parseFloat(ze);
	sf = parseFloat(zf);
	
	
	
	vva=(sa*sf-sb*se)*sd;
	
	va = +vva.toFixed(6);
	return va
}


export function bcalet(za,zb,zc,zd,ze,zf)
{
    sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	 sd = parseFloat(zd);
    se = parseFloat(ze);
	sf = parseFloat(zf);
	
	
	
	vva=(sa*sf-(sb-sc)*se)*sd;
	
	va = +vva.toFixed(6);
	return va
}

export function bcalepc1(za,zb,zk,zc,zd,zl,ze,zf,zh)
{
     sa = parseFloat(za);
    sb = parseFloat(zb);
	sk = parseFloat(zk);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	sl = parseFloat(zl);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sh = parseFloat(zh);
	
	
	
	vva=(sc*sd*se+(sa-sb)*sl*se+(sb-sk)*(sl-sd)*se-((sb-sk)/2)*((sb-sk)/2)*3.14/2+sa*sl*(sf-se)-sk*sh*(sf-se))*2
	
	va = +vva.toFixed(6);
	return va
}


export function bcalepc2(za,zb,zk,zc,zd,zl,ze,zf,zh)
{
     sa = parseFloat(za);
    sb = parseFloat(zb);
	sk = parseFloat(zk);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	sl = parseFloat(zl);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sh = parseFloat(zh);
	
	
	
	vva=(((sc-sd)*sd+sd/2*sd/2*3.14)*se+ (sa-sb)*sl*se+ (sb-sk)*(sl-sd)*se-((sb-sk)/2)*((sb-sk)/2)*3.14/2+sa*sl*(sf-se)-sk*sh*(sf-se))*2
	
	va = +vva.toFixed(6);
	return va
}


export function bcalep(za,zb,zc,zd,ze,zf,zg)
{
     sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	
	
	
	vva=(sf*sd*sa-((sb/2*sb/2*3.14)-(sc/2*sc/2*3.14))*se)*2;
	
	va = +vva.toFixed(6);
	return va
}


export function bcalefds(za,zb,zk,zc,zd,zl,ze,zf,zh,zn)
{
      sa = parseFloat(za);
    sb = parseFloat(zb);
	sk = parseFloat(zk);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	sl = parseFloat(zl);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sh = parseFloat(zh);
	sn = parseFloat(zn);
	
	
	
	vva=((sc*sd*se)+((sa-sb)*sl*se)+sa*sl*(sf-se)-(sk*sh-(sk-sn)*sh)*(sf-se))*2;
	
	va = +vva.toFixed(6);
	return va
}

export function bcalefd2(za,zb,zk,zc,zd,zl,ze,zf,zh,zn,zm)
{
      sa = parseFloat(za);
    sb = parseFloat(zb);
	sk = parseFloat(zk);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	sl = parseFloat(zl);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sh = parseFloat(zh);
	sn = parseFloat(zn);
	sm = parseFloat(zm);
	
	
	vva=((sc*sd*se)+((sa-sb)*sl*se)+sa*sl*(sf-se)-(sk*sh-(sk-sn)*sh)*(sf-se)+sm*sc*(sf-se))*2;
	
	va = +vva.toFixed(6);
	return va
}

export function bcalefd3(za,zb,zk,zc,zd,zl,ze,zf,zh,zn,zm)
{
      sa = parseFloat(za);
    sb = parseFloat(zb);
	sk = parseFloat(zk);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	sl = parseFloat(zl);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sh = parseFloat(zh);
	sn = parseFloat(zn);
	sm = parseFloat(zm);
	
	
	
	vva=((sc*sd*se)+((sa-sb)*sl*se)+sa*sl*(sf-se)-(sk*sh-(sk-sn)*sh)*(sf-se)-sm*sc*(sf-se))*2;
	
	va = +vva.toFixed(6);
	return va
}


export function bcalpm(za,zb,zc,zd,ze,zf,zg,zh,zj)
{
      sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	sh = parseFloat(zh);
	sj = parseFloat(zj);
	
	
	
	
	vva=((sa/2*sa/2*3.14-sb/2*sb/2*3.14)/2*sf+(sc/2*sc/2*3.14-sd/2*sd/2*3.14)*se+(sb/2*sb/2*3.14-(sb/2*sb/2*3.14* (Math.asin(sg/2/sb/2)*180/3.14*4/360))-(sh/2*sg/2*2)-sd/2*sd/2*3.14)*(sf-se))*2;
	
	va = +vva.toFixed(6);
	return va
}


export function bcalpq(za,zb,zc,zd,ze,zf,zg,zh)
{
      sa = parseFloat(za);
    sb = parseFloat(zb);
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	sh = parseFloat(zh);
		
	
	vva=(sa*sd*sf-(sb/2*sb/2*3.14*(1-(Math.asin(sg/2/sb/2)*180/3.14*4)/360)-sc/2*sc/2*3.14)*se-((sd-sc)/2*sg/2*2)*sf)*2
	
	va = +vva.toFixed(6);
	return va
}

export function bcalrma(za,zb,zc,zd,ze,zf,zg,zh,zi,zj)
{
      sa = parseFloat(za);
    sb = parseFloat(zb);
	
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	sh = parseFloat(zh);
	si = parseFloat(zi);
	sj = parseFloat(zj);
		
	
	
	vva=(sa*sa*sf-(Math.pow(2,0.5)*sa-sg)*(Math.pow(2,0.5)*sa-sg)*sf/2-2*sj*sf*(Math.pow(sb*sb-sj*sj,0.5)-sh)-2*sf*(Math.pow(2,0.5)/2*sa-Math.pow(sb*sb-sj*sj,0.5)+sh/2)*(Math.pow(2,0.5)/2*sa-Math.pow(sb*sb-sj*sj,0.5)+sh/2)-sb*sb/2*se*Math.acos(sj/sb)-sh*sh/2*se*Math.tan(3.14/2-Math.acos(sj/sb))-(sg-sb)*(sf-se)*si*2+3.14/4*se*sc*sc-(3.1415926/4*sf*sd*sd))*2;
	va = +vva.toFixed(6);
	return va
}

export function bcalrmb(za,zb,zc,zd,ze,zf,zg,zh,zi,zj)
{
      sa = parseFloat(za);
    sb = parseFloat(zb);
	
	sc = parseFloat(zc);
	sd = parseFloat(zd);
	
	se = parseFloat(ze);
	sf = parseFloat(zf);
	sg = parseFloat(zg);
	sh = parseFloat(zh);
	si = parseFloat(zi);
	sj = parseFloat(zj);
		
	
	
	vva=(sa*sa*sf-(Math.pow(2,0.5)*sa-sg)*(Math.pow(2,0.5)*sa-sg)*sf/2-2*sj*sf*(Math.pow(sb*sb-sj*sj,0.5)-sh)-2*sf*(Math.pow(2,0.5)/2*sa-Math.pow(sb*sb-sj*sj,0.5)+sh/2)*(Math.pow(2,0.5)/2*sa-Math.pow(sb*sb-sj*sj,0.5)+sh/2)-sb*sb/2*se*Math.acos(sj/sb)-sh*sh/2*se*Math.tan(3.14/2-Math.acos(sj/sb))-(sg-sb)*(sf-se)*si*2+3.14/4*se*sc*sc-(3.1415926/4*sf*sd*sd))*2;
	va = +vva.toFixed(6);
	return va
}